import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import COLORS from "../../../../constants/Colors";
import TruckImage from "../../../../assets/images/truck_image.png";
import WarningIcon from "../../../../assets/images/warning_icon.png";

const TrackingDetailError = ({
  noActiveReq = false,
  closeFunc = () => {},
  failedFetch = false,
  vehRegNo,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
      }}
    >
      <Box
        display={"flex"}
        flexDirection={"row"}
        justifyContent={"end"}
        alignItems={"center"}
        width={"calc(100% - 40px)"}
        sx={{
          opacity: "0.8",
          padding: "20px",
        }}
      >
        <Typography
          fontSize={"0.8rem"}
          fontWeight={600}
          color={COLORS.PRIMARY}
          sx={{
            cursor: "pointer",
          }}
          onClick={closeFunc}
        >
          CLOSE
        </Typography>
      </Box>
      <Box
        flexGrow={1}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            height: "50px",
            width: "50px",
            mt: "-100px",
            mb: "-38px",
            mr: "-140px",
            backgroundImage: `url(${WarningIcon})`,
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }}
        />
        <Box
          sx={{
            height: "120px",
            width: "180px",
            mb: "10px",
            backgroundImage: `url(${TruckImage})`,
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }}
        />
        {noActiveReq && (
          <>
            <Typography
              fontSize={"1rem"}
              fontWeight={500}
              sx={{
                opacity: "0.6",
              }}
            >
              Sorry! No active request for {vehRegNo}.
            </Typography>
          </>
        )}
        {failedFetch && (
          <Typography
            fontSize={"1rem"}
            fontWeight={500}
            textAlign={"center"}
            sx={{
              opacity: "0.6",
            }}
          >
            Sorry! Couldn't find tracking history for {vehRegNo}.
          </Typography>
        )}
        <Typography
          fontSize={"0.8rem"}
          fontWeight={600}
          color={COLORS.PRIMARY}
          sx={{
            cursor: "pointer",
            mt: "20px",
          }}
          onClick={closeFunc}
        >
          Go Back
        </Typography>
      </Box>
    </Box>
  );
};

TrackingDetailError.propTypes = {
  noActiveReq: PropTypes.bool,
  closeFunc: PropTypes.func,
  failedFetch: PropTypes.bool,
  vehRegNo: PropTypes.string,
};

export default TrackingDetailError;
